import React, {FC} from 'react';
import {FilterCard} from '../../../../atoms/FilterCard/FilterCard';
import {
  HighlightBrand,
  HighlightedBrandType,
} from '../../FilterContent/Brand/types';
import {GenericFilterItemGroup} from '../../FilterContent/Shared/GenericFilteredItems/types';
import {FilterFlyoutSearch} from '../Shared/FilterFlyoutSearch';
interface Props {
  activeBrandIds: Array<string>;
  excludedHighlightedBrands?: Array<string>;
  favoriteBrandsActive?: boolean;
  hide: VoidFunction;
  submit: VoidFunction;
  isOpen: boolean;
  brandGroups: Array<GenericFilterItemGroup>;
  highlightedBrands?: Array<HighlightBrand>;
  highlightedBrandsType?: HighlightedBrandType;
  label: string;
  onBrandClick: (itemId: string, itemSlug?: string) => void;
  onHighlightedBrandClick: (brandId: string, brandSlug?: string) => void;
  highlightedBrandsLabel: string;
  onFavoriteBrandsToggle: () => void;
  open: () => void;
}

const FlyoutFilter = (props: Props) => {
  const {
    hide,
    isOpen,
    activeBrandIds,
    label,
    brandGroups,
    onBrandClick,
    submit,
  } = props;

  return (
    <FilterFlyoutSearch
      hide={hide}
      submit={submit}
      isOpen={isOpen}
      label={label}
      activeIds={activeBrandIds}
      itemGroups={brandGroups}
      onItemClick={onBrandClick}
    />
  );
};

export const FilterFlyoutBrand: FC<Props> = props => {
  const {activeBrandIds, label, open} = props;
  return (
    <div data-testid="filterFlyoutSectionBrand">
      <FilterCard
        count={activeBrandIds.length ?? undefined}
        title={label}
        onClick={open}
        disableHorizontalPadding={true}
      >
        <FlyoutFilter {...props} />
      </FilterCard>
    </div>
  );
};
